
import Vue from "vue";
import { Component } from "vue-property-decorator";
import AppButton from "./AppButton.vue";
import OrderItem from "./OrderItemNew.vue";

@Component({
  props: {
    askAgain: Boolean,
    orderId: Number,
    imageUrl: String,
    idIcon: String,
    identifier: String,
    titulo: String,
    status: String,
    valor: Number,
    paymentStatus: String,
    paymentMethod: String,
    paymentStatusNumber: Number,
    click: Function,
    items: Array,
    statusColor: String,
    rating: Number || null,
    orderDate: String || null,
  },
  components: { OrderItem, AppButton },
})
export default class CompletedOrdersCard extends Vue {
  statusMap: any = {
    "Novo Pedido": { text: "Novo Pedido", class: "title-header" },
    Produzindo: {
      text: "Pedido em produção",
      class: "title-header",
      style: true,
    },
    "Pedido Pronto": {
      text: "Pedido pronto",
      class: "title-header",
      style: true,
    },
    Pronto: { text: "Pedido pronto", class: "title-header", style: true },
    Enviado: { text: "Pedido enviado", class: "title-header", style: true },
    Finalizado: {
      text: "Pedido finalizado",
      class: "title-header",
      style: true,
    },
    "Pedido Pendente": {
      text: "Pedido pendente",
      class: "title-header-pendent",
    },
    "Confirmar Pedido": {
      text: "Pedido confirmado",
      class: "title-header-confirm",
    },
    Novo: { text: "Pedido em andamento", class: "title-header" },
    "Em preparo": {
      text: "Pedido em preparo",
      class: "title-header",
      style: true,
    },
    "Pedido em Produção": {
      text: "Pedido em produção",
      class: "title-header-production",
    },
    Entregue: { text: "Pedido entregue", class: "title-header-ready" },
    Cancelado: { text: "Pedido cancelado", class: "title-header-cancelled" },
  };

  get currentStatus() {
    return this.statusMap[this.$props.status] || null;
  }

  get withinRatingPeriod(): boolean {
    if (this.$props.orderDate) {
      const orderDate = new Date(this.$props.orderDate);
      const now = new Date();
      return now.getTime() - orderDate.getTime() <= 7 * 24 * 60 * 60 * 1000;
    }
    return false;
  }

  goToSurveys(orderId: any) {
    sessionStorage.setItem("ORDER_ID", orderId + "");
    this.$router.push("Surveys");
  }
}
